// removed by extract-text-webpack-plugin
module.exports = {"item_wrapper":"_2DuysIvAc4yYgp9BCugZOW","item_btn":"_1_rfPVYtqpwAkKPjETeQQa","icon_wrapper":"_1W2o8VgQLS8yneHDzRqkg7","first_item":"_3nJuzW9jwEDbjAYkebcNAF","new_project_text":"_2Y8BJepr-VI8c3LvxucUdk","item":"_2y_VQOGkuXp8W8cxZELG8m","status_icon":"_3djSnzfCl-QCPCLoe00jwm","status":"_2nXMM_IZAWHj_GdiE86xOk","agent_name":"_1I2MLC5NPcGmolSQxvjjOu","date":"_3tHsl3Ldp2egmOk-8GyNds","time":"_2b_uhYlu3OB11c4reVxubC","address":"_2p7qEQKkGL-8UBspLUEjqH","title":"_1ETTvwCiZvkHnMGq2L0PA6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Include/list.css
// module id = 3051
// module chunks = 0